export default __webpack_public_path__ + "static/15-cd3fcdaa887a2ec4d8910f8afaf677f8.jpg";